import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import InnerBox from '@repo/ui/inner-box'

import { Center } from '../../../lib/types/models/center/center'
import { CenterProperties } from '../../../lib/types/models/center/properties.center'
import { TripProperties } from '../../../lib/types/models/trip/properties.trip'
import PeriodBadge from '../../elements/period-badge'

type Props = {
  center: Center
}

const CenterEventCenterInformation = ({ center }: Props) => {
  const journeys = CenterProperties.getCenterJourneyInformation(center)

  return (
    <div className="gap-4 flex flex-col">
      <InnerBox
        title="Liste des séjours"
        titleColor={tailwindColors.grey.DEFAULT}
        className="rounded-lg"
      >
        <div className="flex gap-2 items-center flex-wrap">
          {journeys.map((journey, index) =>
            journey.period ? (
              <PeriodBadge key={index} period={journey.period} text={journey.title} />
            ) : (
              <Badge key={index} text={journey.title} />
            )
          )}
        </div>
      </InnerBox>
      <InnerBox
        title="Liste des voyages"
        titleColor={tailwindColors.grey.DEFAULT}
        className="rounded-lg "
      >
        <div className="flex flex-wrap gap-2">
          {center.tripPlacesRequests.map(({ trip }) => (
            <Badge key={trip.id} variant="white" text={TripProperties.getTripLabel(trip)} />
          ))}
        </div>
      </InnerBox>
    </div>
  )
}

export default CenterEventCenterInformation
